export default __webpack_public_path__ + "static/pp-urban-8ae37c8f4377fae692dcfb087367751d.webp";